export const environment = {
  APPLICATION_NAME: 'LabResult',
  API_BASE_URL: 'https://labresult.agrifirm.com',
  APIM_BASE_URL: 'http://localhost:4200/external',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'https://labresult.agrifirm.com',
  LOGIN_TYPE: 'redirect',
  SIGNUP_SIGNIN_POLICY: 'B2C_1A_EmployeeSignin',
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: 'LabResult',
  APP_INSIGHTS_KEY: '85cd43e7-c453-4fae-af0f-f11c73380889',
  DEFAULT_LOCALE: 'nl-NL',
  LOCALES: 'nl-NL,en-US',
  PRODUCTION: 'true',
  RELATIONSHIPS_ELASTIC_SEARCH: 'true',
  DAIRY_RESULTS_URL: 'https://dairy-results.agrifirm.com',
  DAIRY_RATION_URL: 'https://dairy-ration.agrifirm.com',
};
